import { render, staticRenderFns } from "./TCLAOrphans.vue?vue&type=template&id=079a98aa&scoped=true"
import script from "./TCLAOrphans.vue?vue&type=script&lang=js"
export * from "./TCLAOrphans.vue?vue&type=script&lang=js"
import style0 from "./TCLAOrphans.vue?vue&type=style&index=0&id=079a98aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079a98aa",
  null
  
)

export default component.exports